/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MissionResponse } from '../models/MissionResponse';
import type { MissionTypeResponse } from '../models/MissionTypeResponse';
import { request as __request } from '../core/request';
import { RequestResponseLogs } from "../models/RequestResponseLogs";
import type { Mission } from '../models/Mission';

export class MissionService {

    /**
     * @returns MissionResponse
     * @throws ApiError
     */
    public static async missionIndex(): Promise<MissionResponse> {
        const result = await __request({
            method: 'POST',
            path: `/api/mission`,
        });
        return result.body;
    }

    /**
     * @returns MissionTypeResponse
     * @throws ApiError
     */
    public static async missionType({
        code,
    }: {
        code?: string | null,
    }): Promise<MissionTypeResponse> {
        const result = await __request({
            method: 'POST',
            path: `/api/mission/type`,
            query: {
                'code': code,
            },
        });
        return result.body;
    }

    /**
    * @returns Mission
     * @throws ApiError
    */
    public static async viewMission({
        missionId,
    }: {
        missionId: string | null,
    }): Promise<Mission> {
        const result = await __request({
            method: 'GET',
            path: `/api/mission/view/${missionId}`,
        });
        return result.body;
    }

    public static async getRequestResponseLogs(): Promise<RequestResponseLogs> {
        const result = await __request({
            method: "GET",
            path: `/api/mission/requestResponseLogs`,
        })
        return result.body;
    }

}